import React from 'react';
import { CurrencyText } from '@components/currency';
import { useUserBalance } from '../../hooks';

export const UserBalance = () => {
  const { coins } = useUserBalance();
  return <CurrencyText value={coins} />;
};
